<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            codeGroupCd="JOINT_INSPECTION_TYPE_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="jointInspectionTypeCd"
            label="합동점검종류"
            v-model="searchParam.jointInspectionTypeCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 기간 -->
          <c-datepicker
            :range="true"
            label="LBLPERIOD"
            defaultStart="-6M"
            defaultEnd="6M"
            name="period"
            v-model="period"
          />
        </div>
      </template>
    </c-search-box>
    <!-- 합동점검 목록 -->
    <c-table
      ref="table"
      title="LBL0003084"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!-- 등록 -->
          <c-btn v-if="editable" label="LBLREG" icon="add" @btnClicked="bookPopup" />
          <!-- 검색 -->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'consolidationCheck',
  data() {
    return {
      searchParam: {
        plantCd: '',
        startYmd: '',
        endYmd: '',
        jointInspectionTypeCd: null,
      },
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            // 사업장
            label: 'LBLPLANT',
            align: 'center',
            style: 'width:180px',
            sortable: true,
          },
          {
            name: 'jointInspectionName',
            field: 'jointInspectionName',
            // 합동점검명
            label: 'LBL0003085',
            align: 'left',
            type: "link",
            sortable: true,
          },
          {
            name: 'jointCompleteFlagName',
            field: 'jointCompleteFlagName',
            // 진행상태
            label: 'LBLPROGRESS',
            align: 'center',
            style: 'width:160px',
            sortable: true,
          },
          {
            name: 'approvalStatusName',
            field: 'approvalStatusName',
            // 상태
            label: '결재상태',
            style: 'width:100px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'inners',
            field: 'inners',
            label: '점검자',
            align: 'center',
            style: 'width:300px',
            sortable: true,
          },
          {
            name: 'jointDt',
            field: 'jointDt',
            // 점검기간
            label: '점검일자',
            align: 'center',
            style: 'width:200px',
            sortable: true,
          },
        ],
        data: [],
      },
      period: [],
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.sai.joint.list.url
      this.getList();
    },
    getList() {
      if (this.period) {
        if (this.period.length == 2) {
          this.searchParam.startYmd = this.period[0];
          this.searchParam.endYmd = this.period[1];
        } else {
          this.searchParam.startYmd = '';
          this.searchParam.endYmd = '';
        }
      } else {
        this.searchParam.startYmd = '';
        this.searchParam.endYmd = '';
      }
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.bookPopup(row);
    },
    bookPopup(result) {
      this.popupOptions.target = () => import(`${"./consolidationCheckDetail.vue"}`);
      this.popupOptions.title = 'LBL0003087'; // 합동점검 상세
      this.popupOptions.param = {
        saiJointInspectionId: result ? result.saiJointInspectionId : '',
      };
      this.popupOptions.width = '95%';
      this.popupOptions.isFull = true;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
